import { render, staticRenderFns } from "./AvatarContextMenuComponent.vue?vue&type=template&id=14b41e95&scoped=true"
import script from "./AvatarContextMenuComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AvatarContextMenuComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AvatarContextMenuComponent.vue?vue&type=style&index=0&id=14b41e95&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b41e95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b41e95')) {
      api.createRecord('14b41e95', component.options)
    } else {
      api.reload('14b41e95', component.options)
    }
    module.hot.accept("./AvatarContextMenuComponent.vue?vue&type=template&id=14b41e95&scoped=true", function () {
      api.rerender('14b41e95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navigation/AppBarToolbarItems/contextMenus/AvatarContextMenuComponent.vue"
export default component.exports